import React, { useEffect, useRef } from "react";
import { HashRouter, useLocation, useNavigate } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { BookingProvider } from "./contexts/BookingContext";
import { Home } from "./pages/Home";
import { FacebookGroup } from "./pages/FacebookGroup";
import { Impressum } from "./pages/Impressum";
import { Datenschutz } from "./pages/Datenschutz";
type Page = "home" | "facebookGroup" | "impressum" | "datenschutz";
type AppProps = {
  page?: Page;
};
const pagePaths: Record<Page, string> = {
  home: "/",
  facebookGroup: "/facebook-gruppe",
  impressum: "/impressum",
  datenschutz: "/datenschutz"
};
export function App({
  page = "home"
}: AppProps) {
  return <HashRouter data-id="element-0" data-mp="2wi5nljineppu">
      <PageSync page={page} data-id="element-1" data-mp="28u5x8kp911bs" />
      <BookingProvider data-id="element-2" data-mp="28te1n9vnj3li">
        <div lang="de" className="min-h-screen w-full bg-cream text-espresso" data-id="element-3" data-mp="28sur4e8bzhhi">
          <Header data-id="element-4" data-mp="23ujksdh8vp41" />
          <main data-id="element-5" data-mp="23v2r0wxj8p28">
            <PageRoutes data-id="element-6" data-mp="23ti8y6semyl9" />
          </main>
          <Footer data-id="element-7" data-mp="3ikr0e3urxc7u" />
        </div>
      </BookingProvider>
    </HashRouter>;
}

/**
 * Resolves the current page from the URL. Matches on the end of the path (and on a `?path=`
 * parameter) so the pages also work when the site is served under a sub-path or inside a preview.
 */
function PageRoutes() {
  const location = useLocation();
  const queryPath = new URLSearchParams(location.search).get("path");
  const path = (queryPath ?? location.pathname).replace(/\/+$/, "");
  if (path.endsWith("/impressum")) return <Impressum data-id="element-8" data-mp="33nges1of2pye" />;
  if (path.endsWith("/datenschutz")) return <Datenschutz data-id="element-9" data-mp="38lrs4mdx7ild" />;
  if (path.endsWith("/facebook-gruppe")) return <FacebookGroup data-id="element-10" data-mp="38kgmsi4tu2s5" />;
  return <Home data-id="element-11" data-mp="3dkuufz2inapn" />;
}
function PageSync({
  page
}: {
  page: Page;
}) {
  const navigate = useNavigate();
  // Only navigate when the Controls value actually changes – never on mount or re-mount,
  // so clicking links inside the site is never overridden.
  const previous = useRef(page);
  useEffect(() => {
    if (previous.current === page) return;
    previous.current = page;
    navigate(pagePaths[page]);
  }, [page, navigate]);
  return null;
}